export default __webpack_public_path__ + "static/media/4-min.ae013dfb.jpg";